"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBarComponent = exports.ACTIVE_FILTER_TYPES = void 0;
const react_1 = __importStar(require("react"));
const debounce_1 = __importDefault(require("debounce"));
const ramda_1 = require("ramda");
const react_redux_1 = require("react-redux");
const settings_panel_1 = require("./settings-panel");
const side_bar_styles_1 = require("./side-bar.styles");
// this is temporary while work on EN-3049 is in progress
// when EN-3049 is complete, files in the v2 folds will replace the existing files
const v2_1 = require("../attributes/v2");
const v2_2 = require("../categories/v2");
const v2_3 = require("../taxonomy-classes/v2");
const constants_1 = require("../../../constants");
const feature_flags_1 = require("../../../feature-flags");
const hooks_1 = require("../../../hooks");
const components_1 = require("..");
const store_1 = require("../../../store");
const State = __importStar(require("../../../store/state"));
exports.ACTIVE_FILTER_TYPES = [
    State.ProductFilterActiveTypes.All,
    State.ProductFilterActiveTypes.Active,
    State.ProductFilterActiveTypes.Inactive,
];
const SideBarComponent = ({ classTotals, categoryTotals, attributeTotals, isProductCountsLoading, selectedOrganization, onSetOrganization, activeFilter, onChangeFilter, availableRefinementsFilter, onRefinementsFilter, resultsFilter, onChangeFilterOperator, isOrganizationSelected, isCategoriesLoading, onResetAllFilters, organizations, }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { featureFlagsService } = (0, hooks_1.useFeatureFlagsService)();
    const isMultiFacetNavEnabled = featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.MultiFacetNav);
    const openCategories = (0, store_1.useFacetNavigationOpenCategoriesSelector)();
    const openAttributes = (0, store_1.useFacetNavigationOpenAttributesSelector)();
    const openTaxonomyClasses = (0, store_1.useFacetNavigationOpenTaxonomyClassesSelector)();
    const debouncedSearchTerm = (0, store_1.useFacetNavigationSearchTermSelector)();
    const handleSetOpenCategories = (0, ramda_1.compose)(dispatch, store_1.facetNavigationSetOpenCategories);
    const handleSetOpenAttributes = (0, ramda_1.compose)(dispatch, store_1.facetNavigationSetOpenAttributes);
    const handleSetOpenTaxonomyClasses = (0, ramda_1.compose)(dispatch, store_1.facetNavigationSetOpenTaxonomyClasses);
    const handleSetSearchTerm = (0, ramda_1.compose)(dispatch, store_1.facetNavigationSetSearchTerm);
    const handleDebouncedSearchTerm = (0, react_1.useCallback)((0, debounce_1.default)(handleSetSearchTerm, constants_1.SEARCH_QUERY_UPDATE_DELAY), [dispatch]);
    return (react_1.default.createElement(side_bar_styles_1.StyledSideBar, null, react_1.default.createElement(settings_panel_1.SettingsPanel, { organizations: organizations, selectedOrganization: selectedOrganization, onSetOrganization: onSetOrganization, activeFilter: activeFilter, onChangeFilterOperator: onChangeFilterOperator, onSearchTermChange: handleDebouncedSearchTerm, debouncedSearchTerm: debouncedSearchTerm, availableRefinementsFilter: availableRefinementsFilter, resultsFilter: resultsFilter, onChangeFilter: onChangeFilter, onRefinementsFilter: onRefinementsFilter, resetSettingSelections: onResetAllFilters }), isOrganizationSelected && (isMultiFacetNavEnabled ? (react_1.default.createElement(v2_2.CategoriesSideBarSection, { isCategoriesLoading: isCategoriesLoading, debouncedSearchTerm: debouncedSearchTerm })) : (react_1.default.createElement(components_1.CategoriesContainer, { isCategoriesLoading: isCategoriesLoading, debouncedSearchTerm: debouncedSearchTerm, openCategories: openCategories, setOpenCategories: handleSetOpenCategories, isProductCountsLoading: isProductCountsLoading, categoryTotals: categoryTotals }))), isOrganizationSelected && (isMultiFacetNavEnabled ? (react_1.default.createElement(v2_3.TaxonomyClassesContainerv2, { debouncedSearchTerm: debouncedSearchTerm, classTotals: classTotals })) : (react_1.default.createElement(components_1.TaxonomyClassesContainer, { debouncedSearchTerm: debouncedSearchTerm, classTotals: classTotals, isProductCountsLoading: isProductCountsLoading, openTaxonomyClasses: openTaxonomyClasses, onToggleExpand: handleSetOpenTaxonomyClasses }))), isOrganizationSelected && (isMultiFacetNavEnabled ? (react_1.default.createElement(v2_1.AttributesFilterContainerv2, { searchTerm: debouncedSearchTerm })) : (react_1.default.createElement(components_1.AttributesFilterContainer, { searchTerm: debouncedSearchTerm, isProductCountsLoading: isProductCountsLoading, openAttributes: openAttributes, setOpenAttributes: handleSetOpenAttributes, attributeTotals: attributeTotals })))));
};
exports.SideBarComponent = SideBarComponent;
exports.default = exports.SideBarComponent;
